module.exports = __webpack_public_path__ + "img/IndiArt_01.ead56c21.png";